import { createContext } from "react";
import { CategoryData } from "../helper/interface";

export interface CategoriesContextType {
  categories: (CategoryData & { shared?: number; received?: number })[] | null;
  loading: boolean;
  refreshCategories: () => Promise<void>;
}

export const CategoriesContext = createContext<CategoriesContextType | undefined>(
  undefined
);
